import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["saveButton"];

  connect() {
    this.handleMessage = this.handleMessage.bind(this);

    window.addEventListener("message", this.handleMessage);
  }

  disconnect() {
    window.removeEventListener("message", this.handleMessage);
  }

  handleMessage(event) {
    if (event.origin !== window.location.origin) return;

    switch (event.data.type) {
      case "scratch-gui-project-id-updated":
        this.handleProjectIdUpdated(event.data.projectId);
        break;
      case "scratch-gui-remixing-started":
        this.handleRemixingStarted();
        break;
      case "scratch-gui-remixing-succeeded":
        this.handleRemixingSucceeded();
        break;
      case "scratch-gui-saving-started":
        this.handleSavingStarted();
        break;
      case "scratch-gui-saving-succeeded":
        this.handleSavingSucceeded();
        break;
      case "scratch-gui-upload-failed":
        this.handleUploadFailed();
        break;
    }
  }

  handleProjectIdUpdated(projectId) {
    const newPath = `/projects/${projectId}`;
    window.location = newPath;
  }

  displaySavingState = (messageKey) => {
    const saveButton = this.saveButtonTarget;
    const message = saveButton.dataset[`${messageKey}Text`];
    saveButton.innerText = message;
    saveButton.style.setProperty("pointer-events", "none");
    setTimeout(() => {
      saveButton.innerText = saveButton.dataset.defaultText;
      saveButton.style.setProperty("pointer-events", "auto");
    }, 2000);
  };

  handleRemixingStarted() {
    this.displaySavingState("saving");
  }

  handleRemixingSucceeded() {
    this.displaySavingState("saved");
  }

  handleSavingStarted() {
    this.displaySavingState("saving");
  }

  handleSavingSucceeded() {
    this.displaySavingState("saved");
  }

  handleUploadFailed() {
    window.dispatchEvent(new CustomEvent("alert-modal:open"));
  }
}
